import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';

import s from './JoinUs.css';
import cs from '../../commonStyle.css';
import cx from 'classnames';
import messages from '../../../locale/messages';

class JoinUs extends Component {
  render() {
    const { title, content } = this.props;
    return (
      <>
        <div className={cx(s.joinUs)}>
        <div className={cx(s.container)}>
          <div className={cx(s.joinUsContent)}>
            <div className={cx(s.contentTitle)}>
              <h1 className={cx(s.title, s.iconTitle)}>
                {title}
              </h1>
            </div>
            <p className={cx(s.subTitle)}>
              {content}
            </p>
          </div>
        </div>
      </div>
    </>
  );
  }
}

export default withStyles(s, cs)(JoinUs);